import { stringifySearchWith } from '@tanstack/react-router';

// TanStack's own query decoder turns "true", "false" and digit-only values
// into booleans and numbers before any validateSearch runs (router-core's
// qss toValue), so a value written by the SSO issuer or a marketing link
// could change type on the way in and back out. URLSearchParams keeps every
// value the string it was; the route validators parse what they need.
export const searchSerialization = {
  parseSearch: (searchStr: string): Record<string, string> =>
    Object.fromEntries(new URLSearchParams(searchStr)),
  stringifySearch: stringifySearchWith(JSON.stringify),
};
